import React, { useEffect, useState, useRef } from "react";
import Leftsiderbar from "../home/allcmp/Leftsidebar";
import { makeStyles } from "@material-ui/core/styles";
import { Tooltip } from "@material-ui/core";
import MaterialTable from "material-table";
import Top from "../Top";
import { API_URL } from "../../../config";
import { Link, useNavigate } from "react-router-dom";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
const useStyles = makeStyles(() => ({
  customTooltip: {
    backgroundColor: "black",
    fontSize: "15px",
  },
}));

const EditSoftwareAnnouncement = () => {
  const classes = useStyles();
  const navigation = useNavigate();
  const [data, setData] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const deleteToggleModal = () => setDeleteModal(!deleteModal);
  const [deletesuccessModal, setDeletesuccessModal] = useState(false);
  const deletesuccessToggleModal = () =>
    setDeletesuccessModal(!deletesuccessModal);
  const [deviceid, setDeviceid] = useState(null);
  const [fetchdata, setFetchdata] = useState(true);

  const user_type = localStorage.getItem("user_type");

  useEffect(() => {
    editSoftwarelist();
  }, []);
  const deleteDevice = () => {
    fetch(API_URL + "/delete/announcement/by/" + deviceid, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    }).then((response) => {
      if (response.status == 200) {
        response.json().then((resp) => {
          editSoftwarelist();
          deleteToggleModal();
          deletesuccessToggleModal();

          // const interval = setInterval(() => {
          //     location.reload("/")

          // }, 3000);
          // return () => clearInterval(interval);
        });
      } else {
        alert("Network error");
      }
    });
  };

  const editSoftwarelist = () => {
    fetch(API_URL + "/get/all/announcement", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }).then((response) => {
      if (response.status == 200) {
        response.json().then((resp) => {
          let _temp = [];
          resp.data.map((v, i) => {
            _temp.push({
              headline: v.headline == null ? "NA" : v.headline,
              status:
                v.status == null ? "NA" : v.status == 1 ? "Active" : "Inactive",
              created:
                v.created == null
                  ? "NA"
                  : v.created == 0
                  ? "NA"
                  : new Date(v.created).toLocaleDateString(),
              action: (
                <ul className="action-list">
                  <li>
                    <Tooltip
                      classes={{
                        tooltip: classes.customTooltip,
                      }}
                      title="Edit"
                      placement="top"
                    >
                      <Link
                        to={"/new-software-announcement/" + v.id}
                        className="view-patient"
                      >
                        <i
                          className="fa fa-pencil-square-o"
                          aria-hidden="true"
                        ></i>
                      </Link>
                    </Tooltip>
                    {user_type != 8 && (
                      <Tooltip
                        classes={{
                          tooltip: classes.customTooltip,
                        }}
                        title="Delete"
                        placement="top"
                      >
                        <a
                          href="javascript:void(0)"
                          onClick={() => {
                            deleteItempopUp(v.id);
                          }}
                          className="view-patient"
                        >
                          <i className="fa fa-trash" aria-hidden="true"></i>
                        </a>
                      </Tooltip>
                    )}
                  </li>
                </ul>
              ),
            });
          });
          setFetchdata(false);
          setData(_temp);
        });
      }
    });
  };
  const columns = [
    {
      title: "Update Headline",
      field: "headline",
    },
    {
      title: "Status",
      field: "status",
    },
    {
      title: "Date",
      field: "created",
    },
    {
      title: <span className="text-right">Action</span>,
      field: "action",
    },
  ];
  const deleteItempopUp = (id) => {
    if (deleteModal == false) {
      setDeviceid(id);
      setDeleteModal(!deleteModal);
    } else {
      setDeviceid(id);
      setDeleteModal(deleteModal);
    }
  };
  const handleGoBack = () => {
    navigation("/software-announcement");
  };
  return (
    <div className="">
      <div className="cmail">
        <Top />
      </div>
      <div className="wrp-dashbord">
        <div className="cemail-left">
          <Leftsiderbar />
        </div>
        <div className="right-section">
          <div className="add-btn-wrp add-btn-wrp2">
            <div className="head-listing">
              <h3>Software Announcements</h3>
            </div>
            <div className="add-btn">
              <button onClick={handleGoBack}>Go Back</button>
            </div>
          </div>

          <Modal
            isOpen={deleteModal}
            toggle={deleteToggleModal}
            className="connect-box"
            centered={true}
          >
            <ModalBody>
              <div className="deletemodal-content">
                <h6>
                  <i
                    onClick={() => setDeleteModal(false)}
                    className="fa fa-times"
                    aria-hidden="true"
                  ></i>
                </h6>
                <div className="deleteCircle">
                  <i className="fa fa-trash" aria-hidden="true"></i>
                </div>
                <h3>Are you sure?</h3>
                <p className="para">
                  Do you really want to delete the record? This process cannot
                  be undone.
                </p>

                <div className="butn-wrp">
                  <button
                    className="delete-cancel-btn"
                    onClick={deleteToggleModal}
                  >
                    Cancel
                  </button>
                  <button onClick={deleteDevice}>Delete</button>
                </div>
              </div>
            </ModalBody>
          </Modal>

          <Modal
            isOpen={deletesuccessModal}
            toggle={deletesuccessToggleModal}
            className="connect-box"
            centered={true}
          >
            <ModalHeader toggle={deletesuccessToggleModal}>
              <span className="ml-1 roititle ">Successfull</span>
            </ModalHeader>
            <ModalBody>
              <div className="modal-paragrph">
                <p>Software announcement has been deleted successfully</p>
              </div>
            </ModalBody>
          </Modal>

          <div className="wrp-bankform">
            <div className="mobiletable">
              <div style={{ maxWidth: "100%" }}>
                {fetchdata ? (
                  <div className="norecordfound">Fetching record</div>
                ) : (
                  data.length > 0 && (
                    <MaterialTable
                      options={{
                        search: true,
                        showTitle: false,
                        pageSize: [
                          data.length >= 5
                            ? 5
                            : data.length > 5 && data.length <= 10
                            ? 10
                            : data.length < 10 && data.length <= 20
                            ? 20
                            : data.length > 20 && data.length <= 50
                            ? 50
                            : data.length > 50 && data.length <= 100
                            ? 100
                            : 150,
                        ],
                        pageSize:
                          data.length <= 5
                            ? 5
                            : data.length > 5 && data.length <= 10
                            ? 10
                            : data.length > 10 && data.length <= 20
                            ? 20
                            : data.length > 20 && data.length <= 30
                            ? 30
                            : data.length > 30 && data.length <= 40
                            ? 40
                            : data.length > 40 && data.length <= 50
                            ? 50
                            : data.length > 50 && data.length <= 100
                            ? 100
                            : 150,
                        pageSizeOptions: [5, 10, 20, 50, 100],
                      }}
                      columns={columns}
                      data={data}
                      title=""
                    />
                  )
                )}

                {fetchdata
                  ? ""
                  : data.length == 0 && (
                      <MaterialTable
                        options={{
                          showTitle: false,
                        }}
                        columns={columns}
                        showTitle={false}
                        pagination={true}
                      />
                    )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditSoftwareAnnouncement;
